import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {  TranslationService,
          UserService,
          LoginGuard,
          SidebarService,
          CategoriaInscripcionService,
          ActividadesService,
          CategoriaTrabajoService,
          CongresosService,
          CodigoInvitacionService,
          AdminGuard,
          UploadService,
          TrabajosService,
          CategoriaTrabajoInvitadoService,
          TrabajosInvitadosService,
          MailService,
          InscriptosActividadService,
          NotificationsService } from '../services/services.index';

import { ModalCategInscService } from '../components/modal-categ-insc/modal-categ-insc.service';
import { ModalActividadService } from '../components/modal-actividad/modal-actividad.service';
import { ModalCategTrabajoService } from '../components/modal-categ-trabajo/modal-categ-trabajo.service';
import { ModalCategTrabajoInvitadoService } from '../components/modal-categ-trabajo-invitado/modal-categ-trabajo-invitado.service';
import { ModalUsuarioAdminService } from '../components/modal-usuario-admin/modal-usuario-admin.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [
    TranslationService,
    UserService,
    LoginGuard,
    SidebarService,
    CategoriaInscripcionService,
    ModalCategInscService,
    ModalActividadService,
    ModalCategTrabajoInvitadoService,
    ActividadesService,
    CategoriaTrabajoService,
    ModalCategTrabajoService,
    CongresosService,
    CodigoInvitacionService,
    AdminGuard,
    UploadService,
    TrabajosService,
    CategoriaTrabajoInvitadoService,
    TrabajosInvitadosService,
    ModalUsuarioAdminService,
    MailService,
    InscriptosActividadService,
    NotificationsService
  ]
})
export class ServiceModule { }



// WEBPACK FOOTER //
// ./src/app/services/service.module.ts